module.exports = __webpack_public_path__ + "static/img/4ea0b20a-675a-4cfa-8018-dba7f2ebbcce.eb3158c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/4ea0b20a-675a-4cfa-8018-dba7f2ebbcce.png
// module id = FRhN
// module chunks = 0